const dataPlatformApiUri = process.env.aerialPlotConnections.aerialDataPlatformApi.baseUrl;

/**
 * Returns Promise<AerialPlotResponse> (JSON result object)
 */
export function alignPlots(objectToPass, clientId, accessToken) {
	return fetch(`${dataPlatformApiUri}autoAlign/${clientId}`, {
		headers: {
			Authorization: `Bearer ${accessToken}`,
			"Content-Type": "application/json",
		},
		method: "POST",
		body: JSON.stringify(objectToPass),
	}).then((response) => response.json());
}
